import { render, staticRenderFns } from "./WeightGainOfDifferentGroup.vue?vue&type=template&id=3f6b100a&scoped=true&"
import script from "./WeightGainOfDifferentGroup.vue?vue&type=script&lang=js&"
export * from "./WeightGainOfDifferentGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6b100a",
  null
  
)

export default component.exports